import React, { forwardRef, useState } from "react";
import { Button } from "antd";
import { CloseCircleOutlined, EyeOutlined, SaveOutlined, SearchOutlined } from "@ant-design/icons";
import { AiOutlinePlus } from "react-icons/ai";
import { RiCloseLine, RiEdit2Line } from "react-icons/ri";
import { FilterIcon, ModalPadrao } from "./Base";
import handleTabIndex from "../Utils/HandleTabIndex";

const DEFAULT_VALUES = {
    type: "primary",
    ghost: true,
    borderRadius: 20,
    fontSize: 15,
    minWidth: 100
};

export const BtnBase = forwardRef(({ onClick, showConfirm, txtConfirm, iconDef, ...props }, ref) => {
    const [visible, setVisible] = useState(false);

    const handleClick = () => {
        if (!props.loading && !!onClick) {
            handleTabIndex(props.tabIndex, props.nextTab);
            onClick();
        }
    };

    function preClick() {
        if (!showConfirm)
            return handleClick();

        setVisible(true);
    }

    const icon = !!iconDef ? iconDef({ onClick: preClick }) : null;

    return <>
        {showConfirm && <ModalPadrao visible={visible} onCancel={() => setVisible(false)} width={600} footer={<>
            <BtnGravar txt="Confirmar" onClick={() => { setVisible(false); handleClick(); }} />
            <BtnSair onClick={() => setVisible(false)} />
        </>}>
            <div style={{ textAlign: "center" }}>
                <h2>Deseja prosseguir?</h2>
                <p>{txtConfirm || "operações salvas não poderão ser revertidas."}</p>
            </div>
            {props?.showConfirmExtra}
        </ModalPadrao>}

        {!!icon ? icon : <Button ref={ref} {...props} onClick={preClick}>{props.children}</Button>}
    </>;
});

export function BtnListar({ onClick, ...props }) {
    return <BtnBase {...props} type={DEFAULT_VALUES.type} ghost={DEFAULT_VALUES.ghost} style={{ borderRadius: DEFAULT_VALUES.borderRadius, minWidth: DEFAULT_VALUES.minWidth, ...props.style }} onClick={onClick}>Listar</BtnBase>;
}

export function BtnGravar({ onClick, txt, ...props }) {
    return <BtnBase {...props} type={DEFAULT_VALUES.type} ghost={DEFAULT_VALUES.ghost} style={{ borderRadius: DEFAULT_VALUES.borderRadius, minWidth: DEFAULT_VALUES.minWidth, ...props.style }} icon={<SaveOutlined className="row-verde" style={{ fontSize: DEFAULT_VALUES.fontSize }} />} onClick={onClick}>{txt ? txt : "Gravar"}</BtnBase>;
}

export function BtnSair({ onClick, ...props }) {
    return <BtnBase {...props} style={{ borderRadius: DEFAULT_VALUES.borderRadius, minWidth: DEFAULT_VALUES.minWidth, ...props.style }} icon={<CloseCircleOutlined className="row-vermelho" style={{ fontSize: DEFAULT_VALUES.fontSize }} />} onClick={onClick}>Sair</BtnBase>;
}

export const BtnAdd = forwardRef(({ onClick, noLabel, ...props }, ref) => {
    return <BtnBase ref={ref} {...props} type={DEFAULT_VALUES.type} ghost={DEFAULT_VALUES.ghost} style={{ borderRadius: DEFAULT_VALUES.borderRadius, minWidth: noLabel ? 0 : DEFAULT_VALUES.minWidth, display: "flex", justifyContent: "center", alignItems: "center", ...props.style }} onClick={onClick}>
        <AiOutlinePlus style={{ fontSize: 20 }} /> {!noLabel && <span style={{ marginTop: 2, marginLeft: 5 }}>Incluir</span>}
    </BtnBase>;
});

export function BtnFiltros({ onClick, ...props }) {
    return <BtnBase {...props} type={DEFAULT_VALUES.type} ghost={DEFAULT_VALUES.ghost} style={{ borderRadius: DEFAULT_VALUES.borderRadius, minWidth: DEFAULT_VALUES.minWidth, ...props.style }} icon={<FilterIcon style={{ fontSize: DEFAULT_VALUES.fontSize }} />} onClick={onClick}>Filtros</BtnBase>;
}

export function BtnCancelar({ onClick, txt, ...props }) {
    return <BtnBase {...props} style={{ borderRadius: DEFAULT_VALUES.borderRadius, minWidth: DEFAULT_VALUES.minWidth, ...props.style }} danger icon={<CloseCircleOutlined style={{ fontSize: DEFAULT_VALUES.fontSize }} />} onClick={onClick}>{txt ? txt : "Cancelar"}</BtnBase>;
}

export function BtnLink({ onClick, ...props }) {
    return <BtnBase onClick={onClick} type="link" {...props} >{props.children}</BtnBase>;
}

export function BtnDetalhe(props) {
    return <EyeOutlined className={`${props.small ? 'cad-icon-small' : 'cad-icon'} icon-edit`} {...props} style={{ cursor: "pointer", borderRadius: 50, padding: 3, fontSize: 20, ...props.style }} />;
}

export function BtnEdit(props) {
    return <RiEdit2Line className={`${props.small ? 'cad-icon-small' : 'cad-icon'} icon-edit`} {...props} style={{ cursor: "pointer", borderRadius: 50, padding: 3, ...props.style }} />;
}

export function BtnDeletar(props) {
    return <>
        {props.withLabel ?
            <BtnPadrao {...props} onClick={props.onOk} showConfirm={!props.disableModal}>{props.withLabel}</BtnPadrao>
            : <BtnBase
                onClick={props.onOk}
                showConfirm={!props.disableModal}
                iconDef={(propsInt) =>
                    <RiCloseLine {...props} {...propsInt}
                        className={`${props.small ? 'cad-icon-small' : 'cad-icon'} bg-vermelho`}
                        style={{ cursor: "pointer", color: "#fff", borderRadius: 50, padding: 3, ...props.style }}
                    />}
            />
        }
    </>;
}

export function BtnPadrao({ onClick, ...props }) {
    return <BtnBase {...props} type={DEFAULT_VALUES.type} ghost={DEFAULT_VALUES.ghost} style={{ borderRadius: DEFAULT_VALUES.borderRadius, minWidth: DEFAULT_VALUES.minWidth, ...props.style }} onClick={onClick}>{props.children}</BtnBase>;
}